export const settingsKeys = {
	all: ['settings'] as const,
	flexHotGames: () => [...settingsKeys.all, 'flex-hot-games'] as const,
	flexHotGameList: (filters?: {
		page?: number
		pageSize?: number
		isActive?: boolean
		search?: string
	}) => [...settingsKeys.flexHotGames(), 'list', filters] as const,
	flexHotGame: (id: string) =>
		[...settingsKeys.flexHotGames(), 'detail', id] as const,
	flexMessagePresets: () =>
		[...settingsKeys.all, 'flex-message-presets'] as const,
}
